@if(this.products.length > 0){
<div class="pos-absolute z-4"
     [ngClass]="[bigSpace ? content.shopThisLookTop ? 'top-5' : 'bottom-5' : content.shopThisLookTop ? 'top-2' : 'bottom-2', bigSpace ? content.shopThisLookLeft ? 'left-5' : 'right-5' : content.shopThisLookLeft ? 'left-2' : 'right-2']">
    <button (click)="openTray()"
            [iconButton]="'filled'"
            [textAnimated]="'Shop this look' | translate"
            [status]="trayStatus"
            [icon]="'basket'"
            class="inline-flex"></button>
</div>
}
